import { getIntercomAppID } from "./config";

export function sendBootToIntercom(user) {
  var intercomData = {
    app_id: getIntercomAppID(),
    name: user.firstName + " " + user.lastName,
  };

  var attributeMap = {
    email: "email",
    created_at: "createdAt",
    company_name: "companyName",
    has_verified_email: "hasVerifiedEmail",
    language_code: "languageCode",
    user_id: "uuid",
    user_hash: "securityToken",
    phone: "phoneNumber",
  };

  for (const [key, value] of Object.entries(attributeMap)) {
    intercomData[key] = user[value];
  }

  window.Intercom("boot", intercomData);
  window.Intercom("update", { hide_default_launcher: true });
}

export function resetIntercom() {
  window.Intercom("shutdown");
}

export function showIntercom() {
  window.Intercom("update", { hide_default_launcher: false });
  window.Intercom("show");
}

export function hideIntercom() {
  window.Intercom("hide");
}
